import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { environment } from 'src/environments/environment';
import { SessionLogRequestModel } from '../model/sessionLogsRequest.model';
 
/**
 * @class SessionLogsService
 * @author Saurabh bajpai
 */
@Injectable({
  providedIn: 'root'
})
export class SessionLogsService {

/**
 * 
 * @param httpService HttpService wiil be injected into the component
 */
  constructor(
    private httpService: HttpService,
  ) { }
/**
 * To fetch the filter
 * @param callback function
 */
  fetchFilters(callback: (data) => void) {
    let url = environment.service_url + '/api/sessionLog/fetchFilter';
    let requestParams = new Map();
    this.httpService.get(url, requestParams, (resp) => {
      callback(resp);
    }, (error) => {
      console.log(error);
    });
  }
/**
 * To fetch Logs
 * @param requestModel request model
 * @param callback function
 */
  fetchLogs(requestModel: SessionLogRequestModel, callback: (data) => void) {
    let url = environment.service_url + '/api/sessionLog/logs';
    // if(requestModel && requestModel.optionalEndDate){
    //   requestModel.optionalEndDate= new Date(requestModel.optionalEndDate);
    // }
    let requestParams = new Map();
    this.httpService.post(url, requestModel, requestParams, (resp) => {
      callback(resp);
    }, (error) => {
      console.log(error);
    });
  }
/**
 * To download logs
 * @param requestModel request model
 * @param callback function
 */
  downloadLogs(requestModel : SessionLogRequestModel , callback: (data) => void){
    let url= environment.service_url + '/api/sessionLog/download';
    let requestParams = new Map();
    this.httpService.post(url, requestModel , requestParams, (resp)=>{
      callback(resp);
    }, (error)=>{
      console.log(error);
    });
  }
}
